import { GeoJsonLayer } from "@deck.gl/layers";
import * as chromatic from "d3-scale-chromatic";
import { scaleDiverging } from "d3-scale";

import { color } from "d3-color";

import { pick, pluck } from "ramda";


const ALPHA = 60;
const ALPHA_VALUE = 255 * (ALPHA / 100);

const colorScale = scaleDiverging((t) => chromatic.interpolateRdYlBu(1 - t))
  .domain([-0.75, 0, 0.75])
  .clamp(true);

export function getWorldChoroplethLayers({
  data,
  geoJson,
  onPolygonClick,
  onPolygonHover,
  availableCountries
}) {

  const availableCountriesData = pick(pluck("id")(availableCountries), data || []);

  return getChoroplethLayers({
    data: availableCountriesData,
    geoJson,
    onPolygonClick,
    onPolygonHover,
    level: 0,
    layerId: "world-geojson",
  });
}

export function getCountryChoroplethLayers({
  data,
  geoJson,
  onPolygonClick,
  onPolygonHover,
}) {
  return getChoroplethLayers({
    data,
    geoJson,
    onPolygonClick,
    onPolygonHover,
    level: 1,
    layerId: "country-geojson",
  });
}

export function getCountyChoroplethLayers({
  data,
  geoJson,
  onPolygonClick,
  onPolygonHover,
}) {
  return getChoroplethLayers({
    data,
    geoJson,
    onPolygonClick,
    onPolygonHover,
    level: 3,
    layerId: "county-geojson",
  });
}

export function getStateChoroplethLayers({
  data,
  geoJson,
  onPolygonClick,
  onPolygonHover,
}) {
  return getChoroplethLayers({
    data,
    geoJson,
    onPolygonClick,
    onPolygonHover,
    level: 2,
    layerId: "state-geojson",
  });
}

function getChoroplethLayers({
  data,
  geoJson,
  onPolygonClick,
  onPolygonHover,
  level,
  layerId,
}) {

  const dataAccessor = (d) => {
    return d?.mobilityChange;
  };

  const handlePolygonHover = (info) => {
    const hoveredObject = info.object;

    if (info.object == null) {
      onPolygonHover(null);
    } else {
      const name = hoveredObject?.properties[`NAME_${level}`];
      const value = dataFromPolygon(hoveredObject)?.toFixed(2);
      onPolygonHover({
        name,
        value,
        hoveredObject: info.object,
        pointerX: info.x,
        pointerY: info.y,
      });
    }
  };

  const handlePolygonClick = (event) => {
    if (onPolygonClick) {
      const polygonId = event.object.properties[`ID_${level}`];
      const polygonName = event.object.properties[`NAME_${level}`];
      onPolygonClick({ polygonId, polygonName, level, polygon: event.object });
    }
    if (onPolygonHover) {
      onPolygonHover(null);
    }
  };

  const dataFromPolygon = (p) => {
    return dataAccessor(data[p.properties[`ID_${level}`]]);
  };

  const layerProps = {
    id: layerId,
    data: geoJson,
    opacity: 0.5,
    stroked: true,
    filled: true,
    extruded: false,
    updateTriggers: {
      getFillColor: [data],
    },
    getFillColor(polygon) {
      // return [0xff, 0xff, 0xff, 0xff]
      const count = dataFromPolygon(polygon);
      const colorString = colorScale(count);

      if (colorString != null) {
        const colorInstance = color(colorString);
        return [colorInstance.r, colorInstance.g, colorInstance.b, ALPHA_VALUE];
      } else {
        return [0, 0, 0, 0];
      }
    },
    getLineWidth: 0.5,
    lineWidthUnits: "pixels",
    getLineColor: [105, 105, 105, ALPHA_VALUE],
    pickable: true,
    onClick: onPolygonClick ? handlePolygonClick : undefined,
    onHover: onPolygonHover ? handlePolygonHover : undefined,
  };

  return { layers: [new GeoJsonLayer(layerProps)], colorScale };
}
